import { motion } from "framer-motion";
import { useRef } from "react";
import Message from "../Message/Message";
import { useDeepEffect } from "utils/helper";

const transition = {
    type: "spring",
    stiffness: 200,
    mass: 0.2,
    damping: 20,
};

const variants = {
    initial: {
        opacity: 0,
        y: 30,
    },
    enter: {
        opacity: 1,
        y: 0,
        transition,
    },
};

const MessagesThread = ({
    messages,
    customer,
    openPreviewModal,
    handleResendMessage,
    selectedCustomerMessage,
    selectCustomerMessage,
    keywordSearch,
}) => {
    const messageThread = useRef();

    const scrollToBottom = () => {
        messageThread.current.scrollTop = messageThread.current?.scrollHeight;
    };

    const scrollToKeyword = () => {
        if (!keywordSearch || !messageThread.current) return;
        
        // Wait for DOM to update with highlighted content
        setTimeout(() => {
            // Find the first highlighted keyword element
            const firstHighlight = messageThread.current?.querySelector('[id^="keyword-highlight-"]');
            if (firstHighlight) {
                firstHighlight.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            } else {
                // Fallback to bottom if no highlight found
                scrollToBottom();
            }
        }, 300);
    };

    useDeepEffect(() => {
        if (keywordSearch && keywordSearch.trim().length > 0) {
            scrollToKeyword();
        } else {
            scrollToBottom();
        }
    }, [messages, keywordSearch]);

    return (
        <ol className='message-thread custom-scroll-bar' ref={messageThread}>
            {messages.map((message, i) => {
                return (
                    <motion.li
                        key={message?.messageId}
                        initial='initial'
                        animate='enter'
                        variants={variants}
                        transition={{ duration: 0.2, delay: 0 }}
                        layout>
                        <Message
                            data={{ ...message, keywordSearch }}
                            customer={customer}
                            openPreviewModal={openPreviewModal}
                            handleResendMessage={handleResendMessage}
                            selectedCustomerMessage={selectedCustomerMessage}
                            selectCustomerMessage={selectCustomerMessage}
                        />
                    </motion.li>
                );
            })}
        </ol>
    );
};

export default MessagesThread;
